import React from 'react';
import {
  ITreeMapCell,
} from '../newChart/otherTypes';

import {
  formatTradeValue,
} from '../../numberFormatters';
import {
  GraphExportType,
} from '../../Utils';
import Cell from './Cell';
import CellLabel from './CellLabel';
import {
  bottomMargin,
  leftMargin,
  rightMargin,
  topMargin,
} from './Utils';

interface IProps {
  width: number;
  height: number;
  treeMapCells: ITreeMapCell[];
  total: number;
  exportType: GraphExportType;
}

export default (props: IProps) => {

  const {
    width, height,
    treeMapCells, exportType, total,
  } = props;

  const fullWidth = width + leftMargin + rightMargin;
  const fullHeight = height + topMargin + bottomMargin;

  const cellElems = treeMapCells.map(({x0, y0, x1, y1, color, id}) => (
    <Cell
      key={id}
      x0={x0} y0={y0}
      color={color}
      width={x1 - x0}
      height={y1 - y0}
    />
  ));

  const labels = treeMapCells.map(({id, x0, y0, x1, y1, textLayout}) => (
    <CellLabel
      id={id} x0={x0} y0={y0} x1={x1} y1={y1}
      textLayout={textLayout} exportType={exportType}
      key={id}
    />
  ));

  // Total:
  const totalElem = (
    <text x={leftMargin + width / 2} y={topMargin / 2}>
      {formatTradeValue(total)}
    </text>
  );

  return (
    <svg viewBox={`0 0 ${fullWidth} ${fullHeight}`}
      xmlns='http://www.w3.org/2000/svg'>

      {totalElem}

      <g transform={`translate(${leftMargin}, ${topMargin})`}>
        <g>
          {cellElems}
        </g>
        <g>
          {labels}
        </g>
      </g>
    </svg>
  );
};
